import { createSlice } from "@reduxjs/toolkit";

const defaultPageSetting = { pageSize: 10, pageNo: 0 };

const pageSettingKeys = [
  "order",
  "product",
  "shop",
  "unit",
  "weight",
  "tax",
  "category",
  "subCategory",
  "flavour",
  "addons",
  "bulkList",
  "combo",
  "shape",
  "flatPrice",
];

const pageSettings = pageSettingKeys.reduce((acc, key) => {
  acc[key] = { ...defaultPageSetting };
  return acc;
}, {});

const initialState = {
  platform: "app",
  themeMode: "light",
  taxList: [],
  categoryList: [],
  subCategoryList: [],
  addonsList: [],
  flavourList: [],
  unitList: [],
  weightList: [],
  regionList: [],
  allRegionList: [],
  allBannerList: [],
  bulkList: [],
  orderList: [],
  comboList: [],
  shapeList: [],
  shopList: [],
  promoList: [],
  flatPriceList: [],
  customPromoList: [],
  categoryCodeList: [],
  customerList: [],
  modal: { flag: false, message: "", error: false },
  confirmModal: { flag: false, message: "", action: () => {} },
  userData: {},
  notificationList: [],
  chatNotificationList: [],
  failedOrderNotificationList: [],
  pageSettings,
  productFilters: {
    filterList: [[], [], [], [], [], [], [], [], []],
    apiFilters: {},
  },
  searchSettings: {
    product: "",
    unit: "",
    weight: "",
    tax: "",
    shop: "",
    order: "",
    category: "",
    subCategory: "",
    flavour: "",
    addons: ",",
    bulk: ",",
    combo: ",",
    shape: ",",
    flatPrice: "",
  },
};
export const counterSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    handlePageSettings: (state, action) => {
      state.pageSettings = {
        ...state.pageSettings,
        [action.payload.screen]: {
          pageSize: action.payload.pageSize,
          pageNo: action.payload.pageNo,
        },
      };
    },
    handleProductSearch: (state, action) => {
      // state.settings = {
      //   product: action.payload,
      // };
      state.searchSettings.product = action.payload;
    },
    handleProductFilters: (state, action) => {
      state.productFilters = action.payload;
    },
    handleSearchSettings: (state, action) => {
      const { screen, value } = action.payload;
      if (!state.searchSettings) {
        state.searchSettings = {};
      }
      state.searchSettings[screen] = value;
    },
    storeTaxList: (state, action) => {
      state.taxList = action.payload;
    },
    storeCategoryList: (state, action) => {
      state.categoryList = action.payload;
    },
    storeSubCategoryList: (state, action) => {
      state.subCategoryList = action.payload;
    },
    storeCategoryCodeList: (state, action) => {
      state.categoryCodeList = action.payload;
    },
    storeFlavourList: (state, action) => {
      state.flavourList = action.payload;
    },
    storeUnitList: (state, action) => {
      state.unitList = action.payload;
    },
    storeWeightList: (state, action) => {
      state.weightList = action.payload;
    },
    storeRegionList: (state, action) => {
      state.regionList = action.payload;
    },
    storeAllRegionList: (state, action) => {
      state.allRegionList = action.payload;
    },
    storeAllBannerList: (state, action) => {
      state.allBannerList = action.payload;
    },
    storeAddonsList: (state, action) => {
      state.addonsList = action.payload;
    },
    storeBulkList: (state, action) => {
      state.bulkList = action.payload;
    },
    storeOrderList: (state, action) => {
      state.orderList = action.payload;
    },
    storeComboList: (state, action) => {
      state.comboList = action.payload;
    },
    storeShapeList: (state, action) => {
      state.shapeList = action.payload;
    },
     storePromoList: (state, action) => {
      state.promoList = action.payload;
    },
    storeCustomPromoList: (state, action) => {
      state.customPromoList = action.payload;
    },
    storeCustomerList: (state, action) => {
      state.customerList = action.payload;
    },
    addNotificationList: (state, action) => {
      const newNotification = action.payload;

      if (!Array.isArray(state.notificationList)) {
        state.notificationList = [];
      }

      state.notificationList.push(newNotification);
    },
    removeNotificationItem: (state, action) => {
      const itemIdToRemove = action.payload;
      state.notificationList = state.notificationList?.filter(
        (item) => item.id === itemIdToRemove,
      );
    },
    addChatNotificationList: (state, action) => {
      const newNotification = action.payload;
      if (!Array.isArray(state.chatNotificationList)) {
        state.chatNotificationList = [];
      }
      state.chatNotificationList.push(newNotification);
    },
    removeChatNotificationItem: (state, action) => {
      const itemIdToRemove = action.payload;
      state.chatNotificationList = state.chatNotificationList?.filter(
        (item) => item.chatId != itemIdToRemove,
      );
    },
    addFailedOrderNotificationList: (state, action) => {
      const newNotification = action.payload;
      if (!Array.isArray(state.failedOrderNotificationList)) {
        state.failedOrderNotificationList = [];
      }
      state.failedOrderNotificationList.push(newNotification);
    },
    removeFailedOrderNotificationItem: (state, action) => {
      const itemIdToRemove = action.payload;
      state.failedOrderNotificationList =
        state.failedOrderNotificationList?.filter(
          (item) => item.id !== itemIdToRemove,
        );
    },
    storeFlatpriceList: (state, action) => {
      state.flatPriceList = action.payload;
    },
    userDataReducer: (state, action) => {
      state.userData = action.payload;
    },
    showModal: (state, action) => {
      state.modal = {
        flag: true,
        message: action.payload.msg,
        error: action.payload.error,
      };
    },
    hideModal: (state, action) => {
      state.modal = {
        flag: false,
        message: action.payload.msg,
        error: action.payload.error,
      };
    },
    showConfirmModal: (state, action) => {
      state.confirmModal = {
        flag: true,
        message: action.payload.msg,
        action: action.payload.action || (() => {}),
      };
    },
    hideConfirmModal: (state) => {
      state.confirmModal = {
        flag: false,
        message: "",
        action: () => {},
      };
    },
    reset: () => initialState,
    togglePlatform: (state, action) => {
      state.platform = action.payload;
    },
    storeShopList: (state, action) => {
      state.shopList = action.payload;
    },
    toggleTheme: (state) => {
      state.themeMode = state.themeMode === "light" ? "dark" : "light";
    },
  },
});

export const {
  storeTaxList,
  storeCategoryList,
  storeSubCategoryList,
  showModal,
  hideModal,
  userDataReducer,
  storeFlavourList,
  storeUnitList,
  storeWeightList,
  storeRegionList,
  storeAllRegionList,
  storeAddonsList,
  storeBulkList,
  storeOrderList,
  storeComboList,
  storeShapeList,
  showConfirmModal,
  hideConfirmModal,
  addNotificationList,
  removeNotificationItem,
  handleProductSearch,
  handlePageSettings,
  handleSearchSettings,
  addChatNotificationList,
  removeChatNotificationItem,
  addFailedOrderNotificationList,
  removeFailedOrderNotificationItem,
  togglePlatform,
  storeShopList,
  storeAllBannerList,
  handleProductFilters,
  storeCategoryCodeList,
  storePromoList,
  storeCustomPromoList,
  storeFlatpriceList,
  storeCustomerList,
  toggleTheme,
} = counterSlice.actions;

export default counterSlice.reducer;
